export const SET_CREATE_SECTION = 'SET_CREATE_SECTION';
export const SET_CREATE_SECTION_TRIGGER = 'SET_CREATE_SECTION_TRIGGER';
export const SET_STEP_CREATE = 'SET_STEP_CREATE';
export const SET_STEP_CREATE_TRIGGER = 'SET_STEP_CREATE_TRIGGER';

export const CREATE_STORIES = 'CREATE_STORIES';
export const CREATE_STORIES_ASYNC = 'CREATE_STORIES_ASYNC';
export const SET_ACTUAL_STORY = 'SET_ACTUAL_STORY';
export const SET_ACTUAL_STORY_ASYNC = 'SET_ACTUAL_STORY_ASYNC';

export const CREATE_PAYLOAD = 'CREATE_PAYLOAD';
export const CREATE_PAYLOAD_TRIGGER = 'CREATE_PAYLOAD_TRIGGER';

export const SET_PROMPTS = 'SET_PROMPTS';
export const SET_PROMPTS_TRIGGER = 'SET_PROMPTS_TRIGGER';

export const CLEAN_PREV_PROMPTS = 'CLEAN_PREV_PROMPTS';

export const RESET_STORY_STATE = 'RESET_STORY_STATE';

export const UPDATE_STORY = 'UPDATE_STORY';
export const UPDATE_STORY_ASYNC = 'UPDATE_STORY_ASYNC'

export const DELETE_STORY = 'DELETE_STORY';
export const DELETE_STORY_ASYNC = 'DELETE_STORY_ASYNC';

export const SET_PUBLICATION = 'SET_PUBLICATION';
export const SET_CODE = 'SET_CODE'

export const GET_STORY_STATUS = 'GET_STORY_STATUS';
export const GET_STORY_STATUS_TRIGGER = 'GET_STORY_STATUS_TRIGGER';
export const GET_STORY_STATUS_ASYNC = "GET_STORY_ASYNC";


export const SET_PENDING_STORY = 'SET_PENDING_STORY';
export const SET_PENDING_STORY_ASYNC = 'SET_PENDING_STORY_ASYNC';
export const LOAD_PENDING_STORY = 'LOAD_PENDING_STORY';
export const LOAD_PENDING_STORY_ASYNC = 'LOAD_PENDING_STORY_ASYNC';
export const CLEAR_PENDING_STORY = 'CLEAR_PENDING_STORY';